import { PageProps } from "@/pages/_app";
import { memo } from "react";
import PolicyForm from "@feature/policy/policy-form";
import makeForm from "@components/form/make-form";
import { withAuth } from "@feature/auth";

function Presenter(props: PageProps) {
  return makeForm({
    title: props.title,
    breadcrumb: props.breadcrumb,
    component: <PolicyForm {...props} />,
  });
}

export default withAuth(memo(Presenter));
